// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Monitor_image_wrapper__6VQ\\+s {
  margin-right: 1rem;
}

.Monitor_buttons__I2yHa {
  display: flex;
}

@media only screen and (max-width: 768px) {
  .Monitor_image_wrapper__6VQ\\+s {
    display: none;
  }
}
.Monitor_button_row__\\+kcjL {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-left: -11px;
}

.Monitor_h3__Wu97d {
  width: max-content;
  white-space: nowrap;
  grid-area: h3;
}
@media (max-width: 550px) {
  .Monitor_h3__Wu97d {
    white-space: normal;
    width: auto;
  }
}

.Monitor_head__80Afd {
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

@media (max-width: 1580px) {
  .Monitor_create_btn__TKYuf {
    display: flex;
    justify-content: flex-end;
  }
}

@media (max-width: 1580px) {
  .Monitor_create_btn_batch__Fhkoq {
    display: flex;
    justify-content: flex-end;
  }
}
@media (max-width: 1000px) {
  .Monitor_create_btn_batch__Fhkoq {
    justify-content: flex-start;
    margin-left: -11px;
  }
}
@media (max-width: 500px) {
  .Monitor_create_btn_batch__Fhkoq {
    justify-content: flex-end;
  }
}

@media (max-width: 1580px) {
  .Monitor_batch_btn__\\+VAP6 {
    margin-left: -11px;
  }
}
@media (max-width: 1000px) {
  .Monitor_batch_btn__\\+VAP6 {
    display: flex;
    justify-content: flex-end;
  }
}

@media (max-width: 1580px) {
  .Monitor_filters_btn__iUnRD {
    display: flex;
    justify-content: flex-end;
  }
}
@media (max-width: 1000px) {
  .Monitor_filters_btn__iUnRD {
    justify-content: flex-start;
    margin-left: -11px;
  }
}
@media (max-width: 500px) {
  .Monitor_filters_btn__iUnRD {
    justify-content: flex-end;
  }
}

@media (max-width: 1580px) {
  .Monitor_export_btn__yZM-\\+ {
    display: flex;
    justify-content: flex-end;
  }
}

.Monitor_head_title__ShLoi {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.Monitor_show_on_hover__2Mfnm {
  visibility: hidden;
}

.Monitor_row__E4cDS:hover .Monitor_show_on_hover__2Mfnm {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/components/Monitor/Monitor.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;AAAF;AAEE;EALF;IAMI,mBAAA;IACA,WAAA;EACF;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AACF;;AAGE;EADF;IAEI,aAAA;IACA,yBAAA;EACF;AACF;;AAGE;EADF;IAEI,aAAA;IACA,yBAAA;EACF;AACF;AACE;EANF;IAOI,2BAAA;IACA,kBAAA;EAEF;AACF;AAAE;EAXF;IAYI,yBAAA;EAGF;AACF;;AACE;EADF;IAEI,kBAAA;EAGF;AACF;AADE;EALF;IAMI,aAAA;IACA,yBAAA;EAIF;AACF;;AACE;EADF;IAEI,aAAA;IACA,yBAAA;EAGF;AACF;AADE;EANF;IAOI,2BAAA;IACA,kBAAA;EAIF;AACF;AAFE;EAXF;IAYI,yBAAA;EAKF;AACF;;AADE;EADF;IAEI,aAAA;IACA,yBAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAAI;EACE,mBAAA;AAGN","sourcesContent":[".image_wrapper {\n  margin-right: 1rem;\n}\n\n.buttons {\n  display: flex;\n}\n\n@media only screen and (max-width: 768px) {\n  .image_wrapper {\n    display: none;\n  }\n}\n\n.button_row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  margin-left: -11px;\n}\n\n.h3 {\n  width: max-content;\n  white-space: nowrap;\n  grid-area: h3;\n\n  @media (max-width: 550px) {\n    white-space: normal;\n    width: auto;\n  }\n}\n\n.head {\n  padding: 0 30px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.create_btn {\n  @media (max-width: 1580px) {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.create_btn_batch {\n  @media (max-width: 1580px) {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  @media (max-width: 1000px) {\n    justify-content: flex-start;\n    margin-left: -11px;\n  }\n\n  @media (max-width: 500px) {\n    justify-content: flex-end;\n  }\n}\n\n.batch_btn {\n  @media (max-width: 1580px) {\n    margin-left: -11px;\n  }\n\n  @media (max-width: 1000px) {\n    display: flex;\n    justify-content: flex-end;\n\n  }\n}\n\n.filters_btn {\n  @media (max-width: 1580px) {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  @media (max-width: 1000px) {\n    justify-content: flex-start;\n    margin-left: -11px;\n  }\n\n  @media (max-width: 500px) {\n    justify-content: flex-end;\n  }\n}\n\n.export_btn {\n  @media (max-width: 1580px) {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.head_title {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  align-items: center\n}\n\n.show_on_hover {\n  visibility: hidden;\n}\n\n.row {\n  &:hover {\n    .show_on_hover {\n      visibility: visible;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image_wrapper": `Monitor_image_wrapper__6VQ+s`,
	"buttons": `Monitor_buttons__I2yHa`,
	"button_row": `Monitor_button_row__+kcjL`,
	"h3": `Monitor_h3__Wu97d`,
	"head": `Monitor_head__80Afd`,
	"create_btn": `Monitor_create_btn__TKYuf`,
	"create_btn_batch": `Monitor_create_btn_batch__Fhkoq`,
	"batch_btn": `Monitor_batch_btn__+VAP6`,
	"filters_btn": `Monitor_filters_btn__iUnRD`,
	"export_btn": `Monitor_export_btn__yZM-+`,
	"head_title": `Monitor_head_title__ShLoi`,
	"show_on_hover": `Monitor_show_on_hover__2Mfnm`,
	"row": `Monitor_row__E4cDS`
};
export default ___CSS_LOADER_EXPORT___;
